export default __webpack_public_path__ + "assets/Lato-LightItalic.4310bbed01b37dfcee980f6cbc01024d.ttf";